import * as React from 'react'
import styled from 'styled-components'

import Input, { IStyledInputProps } from 'app/components/Input'
import CloseIcon from 'app/icons/Close'
import SearchIcon from 'app/icons/Search'

type TInputProps = React.InputHTMLAttributes<HTMLInputElement> & IStyledInputProps

interface ISearchProps {
  onClose?: () => void
}

export type TProps = TInputProps & ISearchProps

const SearchInput = React.forwardRef<HTMLInputElement, TProps>(({ style, ...props }, ref) => (
  <InputGroup style={style}>
    <LeftIcon>
      <SearchIcon />
    </LeftIcon>
    <Input type="text" withIconLeft ref={ref} {...props} />
    {props.withIconRight && (
      <RightIcon onClick={props.onClose}>
        <CloseIcon />
      </RightIcon>
    )}
  </InputGroup>
))

SearchInput.displayName = 'SearchInput'

const InputGroup = styled.div`
  position: relative;
`

const LeftIcon = styled.div`
  height: 24px;
  width: 24px;
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  color: ${(props) => props.theme.color.gray[50]};
  cursor: pointer;
`

const RightIcon = styled(LeftIcon).attrs({ as: 'button' })`
  left: auto;
  right: 10px;
  border: none;
  margin: 0;
  padding: 0;
  background: transparent;

  :focus {
    outline: none;
    box-shadow: 0px 0px 0px 2px ${(props) => props.theme.color.blue[30]};
    border-radius: 4px;
  }
`

export default SearchInput
